import { Collapse } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { BidModel } from "../../../models/bid/BidModel";
import { OrgBidModel } from "../../../models/bid/OrgBidModel";
import { ReactComponent as Check } from "../../../rsc/check.svg";
import { colorDark, colorPrimary, colorPurpleDark } from "../../../rsc/colors/colors";
import { ReactComponent as Forbidden } from "../../../rsc/ic_forbidden.svg";
import { PRICE_CODE_CAN_PUBLISH_PRICE_NOT_DEMAND, PRICE_CODE_MARKET_CLOSE, PRICE_CODE_NO_ORG_LOCATION } from "../MyPrices";
import { ChangeMarket } from "./ChangeMarket";
import { PriceRow } from "./PriceRow";
import { QBPPriceSection } from "./QBPPriceSection";

type ExpandablePriceProps = {
    bids: OrgBidModel
    isEditable: (org: OrgBidModel, price: BidModel) => boolean
    getPriceStatus: (org: OrgBidModel) => number
    getErrorReason: (org: OrgBidModel) => string | null
    onPriceClick?: (org: OrgBidModel) => void
}

export function ExpandablePrice(props: ExpandablePriceProps) {

    const [open] = useState(true)
    const [selectedBid, setSelectedBid] = useState<BidModel>()

    useEffect(() => {
        const bid = props.bids?.bids?.find(b => b.market_day === selectedBid?.market_day)
        if (bid) {
            setSelectedBid(bid)
        }
    }, [props.bids])

    const handleClick = () => {
        // setOpen(!open)
        props?.onPriceClick(props.bids)
    };

    function getPriceStatusMessage() {
        let icon = <Forbidden style={{ height: "15px", width: "15px" }} />
        let message = ""
        let color = colorPrimary()
        let status = props.getPriceStatus(props.bids)
        if (status === PRICE_CODE_MARKET_CLOSE) {
            message = t('market_close')
            color = colorPurpleDark()
        } else if (status === PRICE_CODE_NO_ORG_LOCATION) {
            message = t('need_mill_position')
            color = colorPurpleDark()
        } else if (status === PRICE_CODE_CAN_PUBLISH_PRICE_NOT_DEMAND) {
            icon = <Check style={{ height: "15px", width: "15px" }} />
            message = t('edit_prices_for_next_days')
        } else {
            icon = <Check fill={colorDark()} style={{ height: "15px", width: "15px" }} />
            message = t('edit_prices_for_all_days')
        }
        return (
            <div style={{ display: "flex", alignItems: "center", marginTop: "15px" }}>
                {icon}
                <p style={{ margin: "0px 0px 0px 7px", color: color, display: "inline-block" }}>{message}</p>
            </div>
        )
    }

    return (
        <div onClick={handleClick} style={{ width: '100%' }}>
            {/* <div style={{ background: colorLightGrey() }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ flex: "1", display: "flex", alignItems: 'center', height: "fit-content", padding: "20px 0 20px 10px", }}>
                        <Demand style={{ height: "20px" }} />
                        <p style={{ margin: "0 0 0 15px", fontSize: "20px", fontWeight: "700" }}>{props.bids.organisationName}</p>
                    </div>

                </div>
            </div> */}
            <ChangeMarket bids={props.bids?.bids ?? []} onSelectedBid={(b: BidModel) => setSelectedBid(b)} />
            {
                selectedBid &&
                <div className="pempem-flex-col" style={{ display: "flex", alignItems: "center", border: "1px solid var(--color-border)", borderRadius: "0 0 8px 8px", background: "var(--color-surface)", padding: "1rem", marginTop: "-1px" }}>
                    <Collapse style={{ display: "inline-block", flex: "1", paddingBottom: "15px", position: "relative", width: '100%' }} in={open} timeout="auto" unmountOnExit>
                        {getPriceStatusMessage()}
                        <PriceRow
                            key={selectedBid.market_day}
                            price={selectedBid}
                            org={props.bids}
                            isEditable={props.isEditable}
                            getErrorReason={props.getErrorReason} />

                    </Collapse>
                    {/* <GroupPriceSection orgId={props.bids.organisationId} basePrice={selectedBid} groupsParam={props.bids.groups} /> */}
                    <QBPPriceSection org={props.bids} basePrice={selectedBid} />
                </div>
            }
        </div>
    )
}
